/*
 * @Author: 彭梦婷
 * @Date: 2026-06-29 16:09:06
 * @LastEditors: 彭梦婷
 * @LastEditTime: 2026-06-29 16:23:48
 * @Description: 
 * @FilePath: \company-web\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui' // 引入组件库
import 'element-ui/lib/theme-chalk/index.css' // 引入样式库

Vue.config.productionTip = false

Vue.use(ElementUI) // 注册组件库

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
